import React from 'react';

import { FormControlLabel } from '@mui/material';

import Switch from '@mui/material/Switch';

import { ColumnActions } from 'components/Grid/types';

import { useStore } from 'utils/hooks/store';

import API from 'utils/api';
import Logger from 'utils/logger';

import { colors } from 'theme/colors';

export type StatusCellProps = {
  row: { uuid: string; settings: { isActive: boolean } };
  actions: ColumnActions;
};

const StatusCell: React.FC<StatusCellProps> = ({ row, actions }) => {
  const { notification } = useStore();
  const {
    settings: { isActive },
    uuid,
  } = row;
  const onClick = (event: React.SyntheticEvent): void => {
    onToggleActive();
    event.stopPropagation();
  };

  const onToggleActive = React.useCallback(async (): Promise<void> => {
    try {
      await API.entities.updateEntityForm('events', uuid, { settings: { isActive: !isActive } })();
      actions.refreshData();
      notification.enqueueSuccessSnackbar('Form has been updated');
    } catch (e) {
      notification.enqueueErrorSnackbar('Form cannot be updated right now.');
      Logger.error(`Invalid update form API response. Form ID: ${uuid}`, e);
    }
  }, [isActive, uuid]);

  return (
    <FormControlLabel
      sx={{
        gap: '12px',
        '& .MuiFormControlLabel-label': {
          color: colors.text.primary,
          fontSize: '14px',
        },
      }}
      control={<Switch size="small" onClick={onClick} checked={isActive} aria-label="Active switch" />}
      label="Active"
    />
  );
};

export default StatusCell;
